import React from 'react';
import { render } from 'react-dom';

import { formatPublishedAtDate } from '../../../utils/helpers';

import stylePost from '../../../styles/pages/post.scss';

import cn from 'classnames';
import { graphql, Link, StaticQuery } from 'gatsby';

const SuggestedElements = (props: any) => {
  const { data } = props;
  const { allGhostPost } = data;

  const suggestedElements =
    typeof document !== 'undefined'
      ? document.querySelectorAll('.ghostSuggestedArticle, .ghostSuggestedArticleRight')
      : [];

  suggestedElements.forEach((suggestedElement: Element) => {
    const suggestedBlog = allGhostPost.edges.find((o: any) =>
      Object.entries(o).some(([k, value]: any) => {
        return value.slug === suggestedElement.classList[1];
      })
    );
    if (suggestedBlog && typeof suggestedBlog.node !== 'undefined') {
      const { title, published_at, feature_image, slug, tags, primary_author } = suggestedBlog.node;
      render(
        <div
          className={cn(
            stylePost.suggestedArticle,
            suggestedElement.classList[0] === 'ghostSuggestedArticleRight'
              ? stylePost.suggestedArticleRight
              : stylePost.suggestedArticleFull
          )}
        >
          <Link className={stylePost.imageWrapper} to={`/${slug}/`}>
            <img data-src={feature_image} />
            {tags && tags[0] && <span className={stylePost.tags}>{tags[0].name}</span>}
          </Link>
          <div className={stylePost.suggestedArticleContent}>
            <h5>Suggested Post</h5>
            <Link to={`/${slug}/`}>
              <h4>{title}</h4>
            </Link>
            <span>
              {formatPublishedAtDate(published_at)} · {primary_author ? primary_author.name : ''}
            </span>
          </div>
        </div>,
        suggestedElement
      );
    }
  });

  return null;
};

export const GhostSuggestedElements = (props: {
  ghostPost: {
    title: string;
    slug: string;
    tags: {
      slug: string;
      name: string;
    }[];
  };
}) => {
  const renderDefaultLayoutSettings = (data: any) => <SuggestedElements data={data} {...props} />;
  return (
    <StaticQuery
      query={graphql`
        query GhostSuggestedQuery {
          allGhostPost(sort: { order: DESC, fields: published_at }, limit: 100) {
            edges {
              node {
                id
                slug
                title
                published_at
                feature_image
                primary_author {
                  name
                }
                excerpt
                tags {
                  slug
                  name
                }
              }
            }
          }
        }
      `}
      render={renderDefaultLayoutSettings}
    />
  );
};
